<template lang="pug">
blockquote.wagtail-titled-quote
  p.wagtail-titled-quote__title {{ value.title }}
  p.wagtail-titled-quote__text {{ value.body }}
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style lang="scss">
.wagtail-titled-quote {
  width: 100%;
  padding: 55px 0 !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

  &::before {
    content: "";
    width: 220px;
    height: 4px;
    background-color: $primary;
    position: absolute;
    top: 0;
    left: 50%;
    margin-left: -110px;
  }

  &::after {
    content: "";
    width: 220px;
    height: 4px;
    background-color: $primary;
    position: absolute;
    bottom: 0;
    left: 50%;
    margin-left: -110px;
  }

  &__title {
    font-size: 162px;
    color: $primary;
    margin-bottom: 30px;
    font-weight: bold;
    line-height: 140px;
  }

  &__text {
    font-family: 'Rubik';
    font-size: 20px;
    color: $primary;
    font-weight: bold;
    margin-bottom: 0;
  }
}
</style>